import React from 'react';
import { ScoreboardType } from '../../../../../enums/scoreboardTypes';
import SchoolHeaderItem from './SchoolHeaderItem/SchoolHeaderItem';
import ClassHeaderItem from './ClassHeaderItem/ClassHeaderItem';
import StudentHeaderItem from './StudentHeaderItem/StudentHeaderItem';

const CardItem = ({ item, activeTabId, onCardClick, onCardHover, onCardLeave, number }) => {

  const isActive = activeTabId && (item.tabId === activeTabId || item.id === activeTabId);

  const handleClick = () => {
    if (onCardClick && item.tabId) {
      onCardClick(item.tabId);
    } else if (onCardClick) {
      onCardClick(item);
    }
  };

  const handleHover = () => {
    if (onCardHover) {
      onCardHover(item);
    }
  };

  const handleLeave = () => {
    if (onCardLeave) {
      onCardLeave(item);
    }
  };

  switch (item.tabId) {
    case ScoreboardType.SCHOOL:
      return (
        <SchoolHeaderItem
          item={item}
          onClick={handleClick}
          onMouseEnter={handleHover}
          onMouseLeave={handleLeave}
          isActive={isActive}
        />
      );

    case ScoreboardType.CLASSES:
      return (
        <ClassHeaderItem
          item={item}
          onClick={handleClick}
          onMouseEnter={handleHover}
          onMouseLeave={handleLeave}
          isActive={isActive}
          number={number}
        />
      );

    case ScoreboardType.STUDENTS:
      return (
        <StudentHeaderItem
          item={item}
          onClick={handleClick}
          onMouseEnter={handleHover}
          onMouseLeave={handleLeave}
          isActive={isActive}
          number={number}
        />
      );

    default:
      return null;
  }
};

export default CardItem;
